import {ModalType} from "../components/AppModal/ModalTypes";
import ContestPreviewPopUp from "../views/PopUps/ContestPreviewPopUp/ContestPreviewPopUp";
import useAppModalService from "./useAppModalService";

const useContestModal = () => {

    const {openModal, closeModal, modalStack, stackSize} = useAppModalService();

    const openContestModal = async (contest) => {
        try {
            const result = await openModal('contestPreview', ModalType.INFO, {
                title: 'Contest Preview',
                subtitle: '',
                details: 'Some details about the player',
                modalComponent: ContestPreviewPopUp,
                onOk: () => console.log('OK clicked'),
                onCancel: () => console.log('Cancel clicked'),
                onClose: () => console.log('Close clicked'),
            }, contest);
        } catch (error) {
            console.error('Error opening modal:', error);
        }
    }

    return openContestModal;
}
export default useContestModal;